import { useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import useAxiosAdminFetch from '../../hooks/useAxiosAdminFetch';
import LazySpinner from '../admin/LazySpinner';

export default function VerifyConfirm() {
  const navigate = useNavigate();
  const { memberGiftNo, storeNo, giftNo } = useParams();
  const { fetchData } = useAxiosAdminFetch(); //로딩의미: api호출중

  const verifyScan = useCallback(async () => {
    try {
      const url = `${process.env.REACT_APP_API_SERVER}user-gift/verify/${memberGiftNo}`;
      const response = await fetchData({
        method: 'POST',
        url: url,
        data: {},
      });

      // 409 에러: 환불 처리 중인 기프트 → 기프트 현황으로 이동
      if (response?.status === 409) {
        Swal.fire({
          icon: 'warning',
          title: '기프트 검증 불가',
          text: '환불 처리 중인 기프트 및 사용완료된 기프트는 검증할 수 없습니다.',
          confirmButtonText: '확인',
        }).then(() => {
          navigate(`/mobile/giftstatus/${storeNo}`);
        });
        return;
      }

      // 403 에러 처리
      if (response?.status === 403 || response?.data?.resultCode === 403) {
        Swal.fire({
          icon: 'warning',
          title: '상점 불일치',
          text: '다른 상점 아이디로 로그인하셨습니다.',
          confirmButtonText: '확인',
        }).then(() => {
          navigate(`/mobile/login/${storeNo}`);
        });
        return;
      }

      const giftNoToUse = giftNo || response?.data?.data?.giftNo;
      if (response.data.data.result) {
        navigate(
          `/mobile/verifysuccess/${storeNo}/${memberGiftNo}/${giftNoToUse}`,
          {
            state: response.data,
          }
        );
      } else {
        navigate(
          `/mobile/verifyfailure/${storeNo}/${memberGiftNo}/${giftNoToUse}`,
          {
            state: response.data.data,
          }
        );
      }
    } catch (error) {
      // 409 에러: 환불 처리 중인 기프트 → 기프트 현황으로 이동
      if (error?.response?.status === 409) {
        Swal.fire({
          icon: 'warning',
          title: '기프트 검증 불가',
          text: '환불 처리 중인 기프트 및 사용완료된 기프트는 검증할 수 없습니다.',
          confirmButtonText: '확인',
        }).then(() => {
          navigate(`/mobile/giftstatus/${storeNo}`);
        });
        return;
      }
      // 403 에러 처리
      if (
        error?.response?.status === 403 ||
        error?.response?.data?.resultCode === 403
      ) {
        Swal.fire({
          icon: 'warning',
          title: '상점 불일치',
          text: '다른 상점 아이디로 로그인하셨습니다.',
          confirmButtonText: '확인',
        }).then(() => {
          navigate(`/mobile/login/${storeNo}`);
        });
        return;
      }
      // navigate('/mobile/login/${storeNo}/normal');
    }
  }, []);

  useEffect(() => {
    verifyScan();
  }, []);

  return (
    <>
      <LazySpinner />
    </>
  );
}
